var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeofence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1630_893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19238 72.421C6.57324 75.1763 8.20469 77.7987 10.066 80.2552L13.5277 77.6134C11.7914 75.3759 10.2666 72.9819 8.97305 70.4624L5.19238 72.421Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44062 54.3611L0.0908203 54.6572C0.375781 57.7402 0.947656 60.79 1.79883 63.7667L6.01191 62.6281C5.23555 59.9265 4.70937 57.1591 4.44062 54.3611Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7116 11.2729H25.6888L23.4114 7.5835C20.7847 9.21982 18.3146 11.0952 16.0327 13.1858L19.0161 16.3741C21.088 14.4737 23.3292 12.7661 25.7116 11.2729Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2779 5.12402V5.19238L59.075 0.842578C56.0705 0.285156 53.0213 0.003125 49.9654 0H49.7148L49.9197 4.3498C52.7236 4.35312 55.5213 4.6123 58.2779 5.12402Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3682 22.6144L9.88379 20.0181C8.03711 22.4837 6.42109 25.1138 5.05566 27.8751L8.95 29.8108C10.1979 27.281 11.6768 24.8718 13.3682 22.6144Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3057 87.0417C18.5904 89.1086 21.0604 90.961 23.6844 92.5756L25.9617 88.8862C23.5316 87.4176 21.2443 85.7249 19.1295 83.8303L16.3057 87.0417Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2014 7.46982C73.5863 5.85088 70.8264 4.47861 67.9572 3.37061L66.3857 7.42432C69.0088 8.44229 71.532 9.70029 73.9238 11.1819L76.2014 7.46982Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3113 5.14697L40.5143 0.888184C37.4889 1.46338 34.5232 2.31729 31.6553 3.43877L33.2494 7.49248C35.8588 6.46416 38.5576 5.679 41.3113 5.14697Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94375 37.645L1.75332 36.438C0.917383 39.4163 0.360742 42.4659 0.0908203 45.5476L4.41777 45.9347C4.66914 43.1304 5.18008 40.3552 5.94375 37.645Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0185 36.2786C97.1694 33.3196 96.0487 30.4456 94.6706 27.6929L90.7534 29.606C92.0112 32.1251 93.0329 34.7552 93.8052 37.463L98.0185 36.2786Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7993 70.3028L94.6937 72.2386C96.0659 69.478 97.179 66.5962 98.0186 63.63L93.8282 62.4458C93.0647 65.1532 92.0507 67.7835 90.7993 70.3028Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7104 83.694H80.6875L83.6254 86.9052C85.9037 84.8241 87.985 82.537 89.8426 80.0729L86.3582 77.4312C84.6719 79.6878 82.7813 81.7843 80.7104 83.694Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.681 45.3427V45.2517L95.354 45.6617C95.4907 47.0509 95.5589 48.4857 95.5589 49.9205C95.5589 51.3552 95.5589 52.6988 95.3767 54.088L99.7036 54.4751C99.8403 52.972 99.9085 51.4234 99.9085 49.9205C99.9085 48.4175 99.8175 46.8685 99.681 45.3427Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3126 22.4778L89.7743 19.8588C87.9161 17.3954 85.8351 15.1083 83.5571 13.0266L80.6421 16.2377C82.7192 18.1397 84.6175 20.2286 86.3126 22.4778Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9887 27.3286C37.4109 27.3286 27.2148 37.5249 27.2148 50.1024C27.2148 62.68 37.4111 72.8763 49.9887 72.8763C62.5662 72.8763 72.7625 62.68 72.7625 50.1024C72.7625 37.5249 62.5662 27.3286 49.9887 27.3286ZM49.9887 68.3214C39.9266 68.3214 31.7695 60.1644 31.7695 50.1022C31.7695 40.0401 39.9266 31.8831 49.9887 31.8831C60.0508 31.8831 68.2078 40.0401 68.2078 50.1022C68.2078 60.1644 60.0508 68.3214 49.9887 68.3214Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9741 96.675C34.8509 97.7831 37.8241 98.6217 40.856 99.1801L41.653 94.8987C38.886 94.3917 36.172 93.6292 33.5456 92.6213L31.9741 96.675Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9883 95.6501V99.9999C53.0445 99.9849 56.0934 99.6952 59.0979 99.1345L58.3008 94.853C55.5596 95.3692 52.7773 95.636 49.9883 95.6501Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.477 92.553H66.4541L68.0256 96.6067C70.8951 95.4903 73.6549 94.1102 76.2697 92.4846L73.9924 88.7952C71.6092 90.2782 69.0932 91.5362 66.477 92.553Z",
    fill: "#7A297F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1630_893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/geofence.faa0ddfb7b6dd852ca8f18938633314b.svg";
export { ForwardRef as ReactComponent };